import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "magento_negotiablequotetemplate"
    }}>{`Magento_NegotiableQuoteTemplate`}</h1>
    <p>{`The Magento_NegotiableQuoteTemplate module allows both sellers and buyers to create templates from an existing Negotiable Quote.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 1.5.2.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      